<template>
    <div id="assembleSubtest">
        <!-- default subtest search input -->
        <v-autocomplete
            id="tryout-subtest-search-topic"
            v-model="query"
            :items="topics"
            item-text="nama"
            dense
            :disabled="!pdisabled"
            return-object
            @change="
                $route.name == 'ModulPembelajaranForm'
                    ? assignItem($event)
                    : assignTopic($event)
            "
            @click="
                showModal = false;
                loadTopics();
            "
            placeholder="Cari berdasarkan bab/subbab"
            outlined
        >
            <template v-slot:prepend-inner>
                <v-icon class="mr-2 my-0 pt-2" justify>mdi-magnify</v-icon>
            </template>
            <template v-slot:append-outer>
                <!-- Subtest search anchor, if clicked shown modal -->
                <v-btn
                    id="tryout-subtest-anchor-topic-btn"
                    height="40px"
                    elevation="0"
                    class="blew--text"
                    color="touchBlue"
                    :disabled="!pdisabled"
                    @click="
                        showModal = true;
                        loadTopics();
                    "
                >
                    Cari Berdasarkan Soal
                </v-btn>
            </template>
        </v-autocomplete>

        <!-- Modal Anchor Search -->
        <v-dialog
            v-model="showModal"
            transition="dialog-top-transition"
            width="940px"
            min-height="537px"
            max-height="771px"
            @click:outside="showModal = false"
            scrollable
        >
            <template v-slot:default="dialog">
                <v-card>
                    <v-card-title class="d-flex" width="100%">
                        <v-row class="py-3 align-center">
                            <v-col cols="5">
                                <!-- Search Bab -->
                                <v-autocomplete
                                    id="tryout-subtest-bab-topic"
                                    v-model="chapterIndex"
                                    hide-details
                                    :items="topics"
                                    item-text="nama"
                                    outlined
                                    dense
                                    return-object
                                    placeholder="Pilih Bab"
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="5">
                                <!-- Search Sub Bab -->
                                <v-autocomplete
                                    id="tryout-subtest-subbab-topic"
                                    hide-details
                                    v-model="subChapterIndex"
                                    :disabled="chapterIndex.subs.length < 1"
                                    :items="chapterIndex.subs"
                                    item-text="nama"
                                    return-object
                                    outlined
                                    dense
                                    placeholder="Pilih Subbab (optional)"
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="2">
                                <!-- Search Button -->
                                <v-btn
                                    id="tryout-subtest-search-topic-btn"
                                    class="pa-0"
                                    height="39px"
                                    block
                                    dark
                                    color="blew"
                                    elevation="0"
                                    @click="search()"
                                >
                                    Cari
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-title>
                    <v-card-text
                        v-if="$route.name == 'ModulPembelajaranForm'"
                        class="px-0"
                        width="100%"
                    >
                        <!-- Datatable Soal -->
                        <app-datatable
                            id="tryout-subtest-datatable-topic"
                            :items="suggestions"
                            :headers="headers"
                            :has-custom-pagination="true"
                            :hasMultiSearch="true"
                            :has-custom-search="true"
                            :custom-pagination-total-pages="maxPage"
                            :custom-pagination-current-page="params.page"
                            :custom-pagination-per-page="10"
                            v-on:dblClicked="assignItem($event)"
                            v-on:changePage="goToPage($event)"
                            v-on:doSearch="
                                filters = $event;
                                doFilter();
                            "
                            v-on:deleteOnFilter="delByOneFilter($event)"
                        ></app-datatable>
                    </v-card-text>
                    <v-card-text v-else class="px-0" width="100%">
                        <!-- Datatable Soal -->
                        <app-datatable
                            id="tryout-subtest-datatable-topic"
                            :items="suggestions"
                            :headers="headers"
                            :has-custom-pagination="true"
                            :hasMultiSearch="true"
                            :has-custom-search="true"
                            :custom-pagination-total-pages="maxPage"
                            :custom-pagination-current-page="params.page"
                            :custom-pagination-per-page="10"
                            v-on:dblClicked="assignAnchor($event)"
                            v-on:changePage="goToPage($event)"
                            v-on:doSearch="
                                filters = $event;
                                doFilter();
                            "
                            v-on:deleteOnFilter="delByOneFilter($event)"
                        ></app-datatable>
                    </v-card-text>
                    <v-card-actions class="justify-end">
                        <v-btn
                            id="tryout-subtest-anchor-close-btn"
                            text
                            @click="dialog.value = false"
                        >
                            Tutup
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </template>
        </v-dialog>

        <!-- List of Subtest -->
        <v-card
            flat
            min-width="713px"
            outlined
            class="mb-2"
            v-bind:key="index"
            :id="'tryout-subtest-topic-' + index"
            v-for="(subtestDetail, index) in details"
        >
            <v-list>
                <template>
                    <v-list-item two-line class="font-weight-bold">
                        <v-list-item-content
                            class="mx-2 my-0"
                            style="max-width: 45px"
                        >
                            <v-list-item-subtitle>
                                <span
                                    class="lightgreynew--text font-weight-500 font-size-12"
                                    >No</span
                                >
                            </v-list-item-subtitle>
                            <v-list-item-subtitle>{{
                                index + 1
                            }}</v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-content v-if="subtestDetail.is_anchor">
                            <v-list-item-subtitle>
                                <span
                                    class="lightgreynew--text font-weight-500 font-size-12"
                                >
                                    Kode Soal
                                </span>
                            </v-list-item-subtitle>
                            <v-list-item-subtitle>
                                {{ subtestDetail.item_code }}
                            </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-content v-else>
                            <v-list-item-subtitle>
                                <span
                                    class="lightgreynew--text font-weight-500 font-size-12"
                                >
                                    Topik
                                </span>
                            </v-list-item-subtitle>
                            <v-list-item-subtitle>
                                {{ getTopicText(subtestDetail) }}
                            </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-content
                            v-if="$route.name == 'ModulPembelajaranForm'"
                        >
                            <v-list-item-subtitle>
                                <span
                                    class="lightgreynew--text font-weight-500 font-size-12"
                                >
                                    Video Pembahasan
                                </span>
                            </v-list-item-subtitle>
                            <v-list-item-subtitle>
                                <a
                                    target="newtab"
                                    :href="subtestDetail.video_pembahasan"
                                    >{{ subtestDetail.video_pembahasan }}</a
                                >
                            </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action
                            class="px-2"
                            v-if="$route.name == 'ModulPembelajaranForm'"
                        >
                            <v-btn
                                id="tryout-subtest-add-video-btn"
                                class="pa-0"
                                width="32px"
                                height="32px"
                                elevation="0"
                                @click="editVideo(subtestDetail)"
                            >
                                <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                        </v-list-item-action>
                        <v-list-item-action
                            class="px-2"
                            v-if="
                                $store.state.tryout.status != 'PUBLISHED' &&
                                index != 0
                            "
                        >
                            <v-btn
                                id="tryout-subtest-increase-sequence-btn"
                                class="pa-0"
                                width="32px"
                                height="32px"
                                elevation="0"
                                @click="moveUp(subtestDetail)"
                            >
                                <v-icon>mdi-menu-up</v-icon>
                            </v-btn>
                        </v-list-item-action>
                        <v-list-item-action
                            class="px-2"
                            v-if="
                                $store.state.tryout.status != 'PUBLISHED' &&
                                index != details.length - 1
                            "
                        >
                            <v-btn
                                id="tryout-subtest-decrease-sequence-btn"
                                class="pa-0"
                                width="32px"
                                height="32px"
                                elevation="0"
                                @click="moveDown(subtestDetail)"
                            >
                                <v-icon>mdi-menu-down</v-icon>
                            </v-btn>
                        </v-list-item-action>
                        <v-list-item-action
                            class="pr-2"
                            v-if="$store.state.tryout.status != 'PUBLISHED'"
                        >
                            <v-btn
                                id="tryout-subtest-confirm-close-btn"
                                class="pa-0 red--text"
                                width="32px"
                                height="32px"
                                dark
                                elevation="0"
                                color="lightred"
                                @click="
                                    dialogConfirm.function = subtestDetail;
                                    dialogConfirm.title =
                                        'Apakah anda yakin akan menghapus soal ini?';
                                    dialogConfirm.open = true;
                                "
                            >
                                <v-icon>mdi-delete-outline</v-icon>
                            </v-btn>
                        </v-list-item-action>
                    </v-list-item>
                </template>
            </v-list>
        </v-card>

        <!-- Modal Video Pembahasan (just used in Moudl Pembelajaran 2022) -->
        <v-dialog v-model="dialogPembahasan" persistent max-width="506px">
            <v-card>
                <v-card-title style="word-break: break-word !important">
                    URL Video Pembahasan
                </v-card-title>
                <v-card-subtitle>
                    Setiap soal wajib mempunyai Video Pembahasan
                </v-card-subtitle>
                <v-card-text>
                    <v-list-item two-line class="pa-0">
                        <v-list-item-content class="pa-0">
                            <v-text-field
                                placeholder="https://"
                                v-model="videoUrl"
                                outlined
                            />
                        </v-list-item-content>
                    </v-list-item>
                    <div v-if="showVideo">
                        <youtube
                            id="tryout-subtest-youtube-url"
                            style="width: 100%"
                            :key="showVideo"
                            class="mt-2"
                            :video-id="$youtube.getIdFromUrl(videoUrl)"
                            ref="youtube"
                        ></youtube>
                    </div>
                    <v-btn
                        block
                        class="font-weight-bold dark--text"
                        depressed
                        color="#FAFAFA"
                        style="
                            box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
                            border-radius: 4px;
                        "
                        @click="showVideo = true"
                        >Preview Video</v-btn
                    >
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="blew"
                        text
                        @click="addVideo(selectedItem, videoUrl, isEdit)"
                    >
                        Selesai
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Modal Confirmation to remove subtest -->
        <v-dialog v-model="dialogConfirm.open" persistent max-width="450">
            <dialog-confirm
                :title="dialogConfirm.title"
                :subtitle="dialogConfirm.subtitle"
                @close="dialogConfirm.open = false"
                @confirm="
                    remove(dialogConfirm.function);
                    dialogConfirm.open = false;
                "
            />
        </v-dialog>

        <!-- <v-dialog v-model="dialogConfirm.open" persistent max-width="506px">
            <v-card>
                <v-card-title
                    class="text-h5"
                    style="word-break: break-word !important"
                >
                    {{ dialogConfirm.title }}
                </v-card-title>
                <v-card-text>
                    {{ dialogConfirm.subtitle }}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="darkFade"
                        text
                        @click="dialogConfirm.open = false"
                    >
                        Batal
                    </v-btn>
                    <v-btn
                        color="blew"
                        text
                        @click="
                            remove(dialogConfirm.function);
                            dialogConfirm.open = false;
                        "
                    >
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog> -->

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import AssembleSubTest from "@/components/tryout/AssembleSubTest";
import Autocomplete from "@/modules/global/components/plugins/Autocomplete";
import DataTable from "@/modules/global/components/plugins/DataTable-c";
import ItembankService from "@/modules/itembank/services/itembank.js";
import ItemChooser from "@/modules/global/components/plugins/ItemChooser";
import AppSpinner from "@/modules/global/components/plugins/Spinner";
import DialogConfirm from "@/modules/global/components/DialogConfirm";

export default {
    name: "app-assemble-subtest",

    components: {
        "app-assemblesubtest": AssembleSubTest,
        "app-autocomplete": Autocomplete,
        "app-datatable": DataTable,
        "app-itemchooser": ItemChooser,
        "app-spinner": AppSpinner,
        "dialog-confirm": DialogConfirm,
    },

    props: {
        subject: null,
        pdisabled: null,
        preinsert: null,
        bundles: null,
    },

    data: function () {
        return {
            showModal: false,
            details: [],
            topics: [],
            lastSequence: 0,
            subtestType: "normal",
            query: "",
            chapterIndex: {
                subs: [],
            },
            subChapterIndex: null,
            suggestions: [],
            headers: [
                { text: "No.", value: "no" },
                { text: "Kode Soal", value: "kode" },
                { text: "Bab", value: "bab" },
                { text: "Sub Bab", value: "sub_bab" },
                { text: "Sub Sub Bab", value: "sub_sub_bab" },
                { text: "eigen", value: "eigen" },
                { text: "label", value: "label" },
                { text: "Aksi", value: "actions" },
            ],
            selectedItem: null,
            dialogConfirm: {
                open: false,
                title: null,
                subtitle: null,
                function: null,
            },
            videoUrl: null,
            dialogPembahasan: false,
            showVideo: false,
            isEdit: false,
            maxPage: 0,
            currentPage: 1,
            filters: [],
            params: {
                page: 1,
                item_code: "",
                bab: "",
                subbab: "",
                subsubbab: "",
                nilai_eigen: "",
                label: "",
            },
            isLoading: false,
        };
    },

    computed: {
        // get detail subtest, just when update subtest
        selectedSubject: function () {
            if (this.$store.getters.selectedSubtest) {
                var subject = {
                    nama: this.$store.getters.selectedSubtest.subject_name,
                    code: this.$store.getters.selectedSubtest.subject_code,
                    picture:
                        this.$store.getters.selectedSubtest.subject_picture,
                };

                return subject;
            }

            return this.subject;
        },
    },

    methods: {
        // regenerate subtest topik choosen text to use ">>"
        getTopicText: function (subtestDetail) {
            if (this.topics.length == 0) return;

            var text = "";
            var chapter = this.topics.find(function (element) {
                return element.kode == parseInt(subtestDetail.bab_code);
            });

            text += chapter.nama;

            if (subtestDetail.sub_bab_code) {
                var subChapter = chapter.subs.find(function (element) {
                    return element.kode == parseInt(subtestDetail.sub_bab_code);
                });

                text += " >> " + subChapter.nama;
            }

            return text;
        },

        // regenerate code by subtest choosen to get detail subtest
        assignTopic: function (selectedTopic) {
            var chapterId = selectedTopic.parentId;
            var chapter = this.topics.find(function (element) {
                return element.id == chapterId;
            });

            var detail = {};
            detail.sequence = this.lastSequence + 1;
            detail.is_anchor = false;
            detail.bab_code = chapter.kode;

            if (selectedTopic.id != 0) {
                var subChapterId = selectedTopic.id;
                var subChapter = chapter.subs.find(function (element) {
                    return element.id == subChapterId;
                });
                detail.sub_bab_code = subChapter.kode;
            }

            detail.text = selectedTopic.nama;
            var level = this.$store.state.tryout.level;
            var type = this.$store.state.tryout.type;
            var code = this.generateItemCode(
                detail.bab_code,
                detail.sub_bab_code,
                type,
                level
            );

            var context = this;
            ItembankService.searchItemByItemCode(code, function (result) {
                if (result.success) {
                    context.details.push(detail);
                    context.lastSequence++;
                } else {
                    context.$store.commit("showAlert", {
                        message:
                            "Topik (" + detail.text + ") tidak memiliki soal!",
                        type: "error",
                    });
                }
            });
        },

        // get code by subtest detail chosen
        generateItemCode: function (babCode, subBabCode, type, level) {
            var code = "";
            switch (level) {
                case "SMA":
                    code += "3";
                    break;
                case "SMP":
                    code += "2";
                    break;
                case "SD":
                    code += "1";
                    break;
                default:
                    code += "3";
            }

            switch (type) {
                case "UJIAN_AKHIR_SEKOLAH":
                    code += "3";
                    break;
                case "UJIAN_AKHIR_NASIONAL":
                    code += "2";
                    break;
                case "SBMPTN":
                    code += "1";
                    break;
                default:
                    code += "4";
            }

            code += this.subject.code;
            code += babCode;

            if (subBabCode) code += subBabCode;

            return code;
        },

        // put subtest chosen to this.selectedItem, and at the end continue to assignAnchor
        assignItem(item) {
            this.selectedItem = item;
            this.showModal = false;
            this.dialogPembahasan = true;
        },

        // get detail subtest chosen and shown modal video pembahasan
        editVideo(item) {
            this.selectedItem = item;
            this.videoUrl = this.selectedItem.video_pembahasan;
            this.dialogPembahasan = true;
            this.isEdit = true;
        },

        // make new atributte video_pembahasan to keep video url
        addVideo(item, url, isEdit) {
            if (isEdit) {
                const indexdata = this.details.findIndex(
                    (soal) => soal.item_code == this.selectedItem.item_code
                );
                this.details[indexdata].video_pembahasan = url;
            } else {
                item.video_pembahasan = url;
                this.assignAnchor(item);
            }

            this.selectedItem = {};
            this.videoUrl = null;
            this.isEdit = false;
            this.showVideo = false;
            this.dialogPembahasan = false;
        },

        // put subtest chosen to subtest list
        assignAnchor: function (anchorItem) {
            this.showModal = false;
            var detail = {};
            detail.sequence = this.lastSequence + 1;
            detail.is_anchor = true;
            detail.item_code = anchorItem.kode;

            if (this.$route.name == "ModulPembelajaranForm") {
                detail.video_pembahasan = anchorItem.video_pembahasan;
            }

            if (this.$route.name === "CreateBundle") {
                detail.tipe_pilihan = anchorItem.tipe_pilihan;
                detail.wacana = anchorItem.wacana;
                detail.soal = anchorItem.soal;
                detail.pilihan = anchorItem.pilihan;
                detail.jawaban = anchorItem.jawaban;
            }

            var found = this.details.find(function (d) {
                return d.item_code == detail.item_code;
            });

            if (!found) {
                this.details.push(detail);
                this.lastSequence++;
                this.reOrderingSequence();
            }
        },

        // change sequence subtest to up
        moveUp: function (subtestDetail) {
            if (currentIndex === 0) return;
            var currentIndex = subtestDetail.sequence - 1;
            var element = this.details.splice(currentIndex, 1)[0];
            this.details.splice(currentIndex - 1, 0, element);
            this.reOrderingSequence();
        },

        // change sequence subtest to down
        moveDown: function (subtestDetail) {
            if (currentIndex === this.details.length - 1) return;
            var currentIndex = subtestDetail.sequence - 1;
            var element = this.details.splice(currentIndex, 1)[0];
            this.details.splice(currentIndex + 1, 0, element);
            this.reOrderingSequence();
        },

        // remove subtest choosen from subtest list (this.details = subtest list)
        remove: function (subtestDetail) {
            var index = subtestDetail.sequence - 1;
            this.details.splice(index, 1);
            this.$emit("deleteSoal", subtestDetail);
            this.reOrderingSequence();
        },

        // reordering subtest number
        reOrderingSequence: function () {
            var context = this;
            this.lastSequence = 0;
            this.details.forEach(function (detail) {
                detail.sequence = context.lastSequence + 1;
                context.lastSequence++;
            });
        },

        // get all topics and regenerate topics text to use ">>" to shown in "default subtest search input"
        loadTopics: function () {
            var context = this;
            ItembankService.getListOfTopic(
                this.subject.code,
                function (result) {
                    if (result.success) {
                        context.topics = [];
                        result.data.forEach(function (topic) {
                            topic.parentId = topic.id;
                            context.topics.push(topic);
                            if (!context.showModal) {
                                if (topic.subs.length > 0) {
                                    topic.subs.forEach(function (sub) {
                                        sub.parentId = null;
                                        sub.nama =
                                            topic.nama + "\n\t>> " + sub.nama;
                                        sub.parentId = topic.id;
                                        context.topics.push(sub);
                                        if (sub.subs.length > 0) {
                                            sub.subs.forEach(function (subsub) {
                                                subsub.parentId = null;
                                                subsub.nama =
                                                    sub.nama +
                                                    "\n\t\t>> " +
                                                    subsub.nama;
                                                subsub.parentId = sub.id;
                                                context.topics.push(subsub);
                                            });
                                        }
                                    });
                                }
                            }
                        });
                    }
                }
            );
        },
        // not used
        traverse: function (query, node, parents, level) {
            if (
                query.length > 3 &&
                node.nama.toLowerCase().indexOf(this.query.toLowerCase()) >= 0
            ) {
                var nodepath = "";
                parents.forEach(function (parent) {
                    nodepath += parent.nama + " >> ";
                });

                this.topics.push({
                    id: node.id,
                    nama: nodepath + node.nama,
                    parents: parents,
                });
            }

            if (parseInt(this.depth) && level === parseInt(this.depth)) {
                return;
            }

            if (node.subs.length === 0) {
                return;
            }

            for (var i = 0; i < node.subs.length; i++) {
                this.traverse(
                    query,
                    node.subs[i],
                    parents.concat(node),
                    level + 1
                );
            }
        },

        goToPage(p) {
            this.params.page = p;
            this.search();
        },

        doFilter() {
            if (this.filters.length > 0) {
                this.filters.forEach((filter, index) => {
                    this.params.page = 1;
                    if (filter.key.value === "kode") {
                        this.params.item_code = filter.value;
                    }
                    if (filter.key.value === "label") {
                        this.params.label = filter.value;
                    }
                    if (filter.key.value === "bab") {
                        this.params.bab = filter.value;
                    }
                    if (filter.key.value === "sub_bab") {
                        this.params.subbab = filter.value;
                    }
                    if (filter.key.value === "sub_sub_bab") {
                        this.params.subsubbab = filter.value;
                    }
                    if (filter.key.value === "eigen") {
                        this.params.nilai_eigen = filter.value;
                    }
                    if (filter.key.value == null && filter.value == null) {
                        this.clearFilter();
                    }
                });
            } else {
                this.clearFilter();
            }
            this.search();
        },

        clearFilter() {
            this.params = {
                page: 1,
                item_code: "",
                label: "",
                bab: "",
                subbab: "",
                subsubbab: "",
                nilai_eigen: "",
            };

            this.search();
        },

        delByOneFilter(filter) {
            filter.value = "";
            var index = this.filters.push(filter) - 1;
            this.doFilter();
            this.filters.splice(index, 1);
        },

        // get detail subtest topic to shown in "Modal Anchor Search" datatable
        search: function () {
            this.suggestions.splice(0, this.suggestions.length);
            var level = this.$store.state.tryout.level;
            var type = this.$store.state.tryout.type;
            var itemCode = this.generateItemCode(
                this.chapterIndex.kode,
                this.subChapterIndex
                    ? this.subChapterIndex.kode
                    : this.subChapterIndex,
                type,
                level
            );

            var params = this.params;
            var context = this;
            context.isLoading = true;

            ItembankService.searchItemByItemCodePaging(
                params,
                itemCode,
                function (result) {
                    if (result.success) {
                        result.data.forEach(function (item, index) {
                            var subChapter = "-";
                            var subSubChapter = "-";

                            if (item.sub_bab != null)
                                subChapter = item.sub_bab.nama;
                            if (item.sub_sub_bab != null)
                                subSubChapter = item.sub_sub_bab.nama;

                            var row = {
                                no: ++index,
                                kode: item.kode,
                                bab: item.bab.nama,
                                sub_bab: subChapter,
                                sub_sub_bab: subSubChapter,
                                eigen: item.nilai_eigen,
                                label: item.label,
                                tipe_pilihan: item.tipe_pilihan,
                                wacana: item.wacana,
                                soal: item.soal,
                                pilihan: item.pilihan,
                                jawaban: item.jawaban,
                            };
                            context.maxPage = item.pages;
                            context.suggestions.push(row);
                        });
                    } else {
                        context.params.page = 1;
                        context.maxPage = 0;
                    }
                    context.isLoading = false;
                }
            );
        },

        // not used
        confirmSelectedItem: function () {
            this.showModal = false;
            this.$emit("selected", this.selectedItem);
        },
    },

    watch: {
        subject: function (val) {
            this.loadTopics();
        },

        details: function (val) {
            this.$emit("updated", this.details);
        },

        bundles: function (val) {
            if (val) {
                this.details = val;
            }
        },
    },

    mounted: function () {
        this.loadTopics();

        // not used
        setTimeout(() => {
            if (this.preinsert) {
                this.details = this.preinsert;
                this.lastSequence = this.preinsert.length;
                this.reOrderingSequence();
            }
        }, 2000);

        // get all list subtest from previous update
        if (this.$store.getters.selectedSubtest) {
            var context = this;
            this.$store.getters.selectedSubtest.details.forEach(function (
                detail
            ) {
                context.details.push(detail);
            });

            this.details.sort(function (a, b) {
                return a.sequence - b.sequence;
            });

            this.lastSequence = this.details.length;
        }
    },
};
</script>



// WEBPACK FOOTER //
// AssembleSubTest.vue?62bad57e